module.exports = __webpack_public_path__ + "img/upx3.352ba11f.svg";